export default __webpack_public_path__ + "static/media/tooltip-info-icon.767ffc5b.svg";